import script from "./DailyTreatedFollowupsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyTreatedFollowupsChart.vue?vue&type=script&setup=true&lang=js"

import "./DailyTreatedFollowupsChart.vue?vue&type=style&index=0&id=4eee4a3b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eee4a3b"]])

export default __exports__